import { cn } from '@/lib/ui/utils';
import type {
  CSSProperties,
  ElementType,
  HTMLAttributes,
  ReactNode,
} from 'react';
import { CmsMediaFrame } from './cms-media-frame';

export type CmsImageRatio = 'landscape' | 'portrait' | 'square';
export type CmsImageSurface = 'transparent' | 'opaque';

const CMS_IMAGE_RATIO_VALUE: Record<CmsImageRatio, string> = {
  landscape: '4 / 3',
  portrait: '3 / 4',
  square: '1 / 1',
};

export function CmsImageFrame({
  as,
  ratio,
  surface = 'transparent',
  className,
  frameClassName,
  children,
  style,
  ...props
}: HTMLAttributes<HTMLElement> & {
  as?: ElementType;
  ratio: CmsImageRatio;
  surface?: CmsImageSurface;
  frameClassName?: string;
  children: ReactNode;
}) {
  const Component = as ?? 'div';

  return (
    <Component
      className={cn('cms-image-frame', className)}
      data-cms-image-ratio={ratio}
      data-cms-image-surface={surface}
      style={
        {
          '--cms-image-frame-ratio': CMS_IMAGE_RATIO_VALUE[ratio],
          ...style,
        } as CSSProperties
      }
      {...props}
    >
      <CmsMediaFrame className={cn('cms-image-frame__inner', frameClassName)}>
        {children}
      </CmsMediaFrame>
    </Component>
  );
}
